import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import ToggleStarredButton from 'Components/ComponentLibrary/Molecules/ToggleStarredButton';
import useResource from 'Hooks/useResource';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { noop } from 'Helpers/PropTypes';

const useStyles = buildUseStyles('ThreadToggleStarredButton', () => ({
  root: {},
}));

const ThreadToggleStarredButton = ({
  className,
  resource,
  color,
  size,
  onChange,
  fullWidth,
  showLabel,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const ATTR_NAME = 'isStarred';
  const { refreshThreads } = useMessagesContext();
  const { setAttribute, resource: threadResource } = useResource(resource);

  const handleClick = async (event, value) => {
    event.preventDefault();
    event.stopPropagation();
    onChange();
    setAttribute(ATTR_NAME, value);
    await threadResource.submit();
    await refreshThreads();
  };

  return (
    <ToggleStarredButton
      className={classNames(className, classes.root)}
      value={threadResource.isTruthy('isStarred')}
      onChange={handleClick}
      color={color}
      size={size}
      fullWidth={fullWidth}
      showLabel={showLabel}
    />
  );
};

ThreadToggleStarredButton.defaultProps = {
  className: '',
  color: 'primary',
  size: 'default',
  onChange: noop,
  fullWidth: false,
  showLabel: false,
};

ThreadToggleStarredButton.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export { ThreadToggleStarredButton };
